/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export default function PenIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.95004 2.73147L11.4505 6.48209L3.84938 14.6265L0.728443 14.9956C0.310641 15.0451 -0.0423555 14.6667 0.00412447 14.219L0.351381 10.8726L7.95004 2.73147ZM13.6155 2.17306L11.9719 0.411993C11.4592 -0.137331 10.6277 -0.137331 10.115 0.411993L8.56877 2.06876L12.0693 5.81941L13.6155 4.16264C14.1282 3.61303 14.1282 2.72239 13.6155 2.17306Z"
        fill="white"
      />
    </svg>
  );
}

PenIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

PenIcon.defaultProps = {
  width: 14,
  height: 15,
};
